import { render, staticRenderFns } from "./add-to-cart-sidebar.vue?vue&type=template&id=3fe3962a&scoped=true&"
import script from "./add-to-cart-sidebar.vue?vue&type=script&lang=js&"
export * from "./add-to-cart-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./add-to-cart-sidebar.vue?vue&type=style&index=0&id=3fe3962a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe3962a",
  null
  
)

export default component.exports